(function () {
  function getLangForCountry(countryCode) {
    return countryCode === 'IT' ? 'it' : 'en';
  }

  // --- Offcanvas ---
  function initOffcanvas() {
    var countrySelect = document.getElementById('localization-country');
    var langSelect = document.getElementById('localization-language');
    if (!countrySelect || !langSelect) return;

    var INTL_LANGS = ['en', 'fr', 'de', 'es'];

    function updateLangSelect(countryCode) {
      var isItaly = countryCode === 'IT';
      Array.from(langSelect.options).forEach(function (opt) {
        opt.hidden = isItaly ? opt.value !== 'it' : opt.value === 'it';
      });
      if (isItaly) {
        langSelect.value = 'it';
      } else if (!INTL_LANGS.includes(langSelect.value)) {
        langSelect.value = 'en';
      }
    }

    var currentLang = langSelect.dataset.currentLang || langSelect.dataset.currentCountry;
    langSelect.value = currentLang;
    updateLangSelect(langSelect.dataset.currentCountry);

    countrySelect.addEventListener('change', function () {
      updateLangSelect(this.value);
    });
  }

  // --- Footer ---
  function initFooter() {
    var langContainer = document.querySelector('.cambiolingua[data-current-country]');
    if (langContainer) {
      var isItaly = langContainer.dataset.currentCountry === 'IT';
      langContainer.querySelectorAll('[name="language_code"]').forEach(function (btn) {
        btn.closest('li').hidden = isItaly ? btn.value !== 'it' : btn.value === 'it';
      });
    }

    document.querySelectorAll('[name="country_code"][type="submit"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = this.closest('form');
        if (!form) return;
        var lang = getLangForCountry(this.value);
        var existing = form.querySelector('input[type="hidden"][name="language_code"]');
        if (existing) {
          existing.value = lang;
        } else {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'language_code';
          hidden.value = lang;
          form.appendChild(hidden);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initOffcanvas();
    initFooter();
  });
})();
